import { Accordion, Nav } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function T8_workshops_mnu({ activeItem }) {
  const navigate = useNavigate();
  const activeStyles = { fontWeight: 600, backgroundColor: '#e7f1ff', color: '#0d6efd' };

  return (
    <Accordion.Item eventKey="9">
      <Accordion.Header>
        <span role="img" aria-label="workshops">🧰</span> Talleres
      </Accordion.Header>
      <Accordion.Body className="p-0">
        <Nav className="flex-column">
          <Nav.Link
            active={activeItem === 'workshops_editor'}
            style={activeItem === 'workshops_editor' ? activeStyles : undefined}
            onClick={() => navigate('/workshops/editor')}
          >
            Editor de Workshops
          </Nav.Link>
         
        </Nav>
      </Accordion.Body>
    </Accordion.Item>
  );
}

export default T8_workshops_mnu;
